import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { withDefaults } from '@warp-drive/legacy/model/migration-support';

export const LtiConsumedToolDeploymentSchema = withDefaults({
  type: DataTypeLti.ConsumedToolDeployment,
  legacy: true,
  identity: {
    kind: '@id',
    name: 'id',
  },
  fields: [
    { kind: 'attribute', name: 'consumedToolId', type: 'string' },
    { kind: 'attribute', name: 'platformDeploymentId', type: 'string' },
    { kind: 'attribute', name: 'resourceLinkClaimPath' },
    { kind: 'attribute', name: 'isActive', type: 'boolean' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'consumedTool',
      type: DataTypeLti.ConsumedTool,
      options: {
        async: true,
        inverse: 'deployments',
      },
    },
    {
      kind: 'hasMany',
      name: 'resourceLinks',
      type: DataTypeLti.ResourceLink,
      options: {
        async: true,
        inverse: 'consumedToolDeployment',
      },
    },
  ],
});
